import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const IronLogo = ({ firstColor = "#3b9478", secondColor = "#1b546a" }) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="43.545"
    height="31.815"
    viewBox="0 0 43.545 31.815"
  >
    <g transform="translate(-295.904 -72.54)">
      <path
        d="M2829.636-800.793l-2-2,4.448-4.449-3.611-3.612,9.557-9.557,3.612,3.611,4.43-4.43,2,2-4.43,4.43,3.612,3.612-9.557,9.556-3.611-3.611-4.448,4.448Zm2.911-10.133,5.217,5.217,5.4-5.4-5.217-5.218Z"
        transform="translate(-2508.622 905.147)"
        fill={firstColor}
      />
      <path
        d="M2456.1-974.343l4.455-4.454-3.614-3.616L2478-1003.473l3.614,3.616,4.288-4.288,2.009,2.009-4.289,4.289,3.6,3.6-21.059,21.06-3.6-3.6-4.454,4.454Z"
        transform="translate(-2160.197 1076.684)"
        fill={secondColor}
      />
    </g>
  </Icon>
);

export default IronLogo;



// WEBPACK FOOTER //
// ./src/components/Icons/IronLogo.js